import {Component, OnInit} from "@angular/core";
import {Router} from "@angular/router";
import {UserService} from "../../users/services/users.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-reset-password-email-sent',
  templateUrl: './reset-password-email-sent.component.html',
  styleUrls: ['./reset-password-email-sent.component.scss'],
  standalone: false
})
export class ResetPasswordEmailSentComponent implements OnInit {

  breadCrumbs = [
    { iconClass: 'bi-house', path: 'https://www.scalanthropy.com/'},
    { label: 'Home', path: 'https://www.scalanthropy.com/'},
    { label: 'Login', path: 'app/login'},
    { label: 'Reset Password Email Sent', path: 'app/login/reset-password-email-sent'}
  ];
  showMessages = false;
  messages: any[] = [];
  username: string = '';

  pageName = 'Successful Payment';

  constructor(private userService: UserService,
              private routerChild: Router,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy Page Not Found");
  }

  ngOnInit() {
    // @ts-ignore
    this.username = localStorage.getItem('resetPasswordEmail');
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    const counterFn = () => {
      this.routerChild.navigateByUrl('app/login');
    }
    setTimeout(counterFn, 6000);
  }

  onGoToLogin(): void {
    this.routerChild.navigateByUrl('app/login');
  }
}
